import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { AngleIcon } from '@/components/UI/Icons/Icons';

export const DropdownIcon = styled(AngleIcon).attrs({
  width: 11.25,
  height: 6.75,
})``;

export const SortButton = styled(Button)`
  font-size: 14px;
  padding: 0;
  height: 17px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const DesktopSortContainer = styled.div`
  position: relative;
`;

export const DesktopSortButton = styled(Button).attrs<{
  $isActive: boolean;
}>({
  appearance: 'transparent',
  height: 40,
  borderRadius: 20,
})`
  display: flex;
  gap: 10px;
  padding: 15px 21px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  user-select: none;

  ${({ $isActive }) =>
    $isActive &&
    css`
      ${DropdownIcon} {
        transform: rotate(180deg);
      }
    `}

  ${({ $isActive }) =>
    !$isActive &&
    css`
      &:hover {
        background-color: ${({ theme }) => theme.palette.tertiary.background};
        color: ${({ theme }) => theme.palette.brand.main};

        & path {
          fill: ${({ theme }) => theme.palette.brand.main};
        }
      }
    `}
`;

export const Menu = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;
  width: 240px;
  padding: 10px;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 15px;
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.1s linear;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const MenuItemText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))``;
